import React, { ReactNode } from 'react';

import { StyleProvider, type StyleProviderProps } from '@ant-design/cssinjs';
import { ConfigProvider, type ThemeConfig } from 'antd';

export const APP_FONT_FAMILY =
  "'Stolzl', 'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif";

export const cabinetTheme: ThemeConfig = {
  hashed: false,
  cssVar: { key: 'app' },
  token: {
    borderRadius: 10,
    colorPrimary: '#0075ff',
    fontFamily: APP_FONT_FAMILY,
  },
};

type Props = {
  children: ReactNode;
  cache?: StyleProviderProps['cache'];
};

const AntdProviders = ({ children, cache }: Props) => (
  <StyleProvider cache={cache} layer>
    <ConfigProvider theme={cabinetTheme}>{children}</ConfigProvider>
  </StyleProvider>
);

export default AntdProviders;
